<div class="revoke-dialog-container">

  <!-- NESSUN PERMESSO DISPONIBILE -->

  <ng-container *ngIf="!hasRevokablePermissions">

    <div class="revoke-empty-state">

      <div class="revoke-empty-icon">
        <i class="pi pi-calendar-times"></i>
      </div>

      <div class="revoke-empty-title">
        Non ci sono permessi da revocare
      </div>

      <div class="revoke-empty-description">
        Al momento non risultano permessi
        disponibili per la revoca.
      </div>

    </div>

  </ng-container>

  <!-- PERMESSI DISPONIBILI -->

  <ng-container *ngIf="hasRevokablePermissions">

    <div class="revoke-form">

      <!-- SELEZIONE PERMESSO -->

      <div class="revoke-field">

        <label
          class="revoke-label"
          for="revoke-permission-select"
        >
          Permesso da revocare
          <span class="revoke-required">*</span>
        </label>

        <p-dropdown
          inputId="revoke-permission-select"
          [(ngModel)]="selectedPermission"
          [options]="permissions"
          [style]="{ width: '100%' }"
          styleClass="revoke-dropdown"
          placeholder="Seleziona un permesso"
          [showClear]="false"
          appendTo="body"
        >

          <ng-template pTemplate="selectedItem">

            <span *ngIf="selectedPermission">
              {{ selectedPermission.delegate?.user?.name }}
              {{ selectedPermission.delegate?.user?.lastName }}
              -
              {{ selectedPermission.permissionDate | date:'dd/MM/yyyy' }}
            </span>

          </ng-template>

          <ng-template pTemplate="item" let-option>

            <span>
              {{ option.delegate?.user?.name }}
              {{ option.delegate?.user?.lastName }}
              -
              {{ option.permissionDate | date:'dd/MM/yyyy' }}
            </span>

          </ng-template>

        </p-dropdown>

      </div>

      <!-- MESSAGGIO INFORMATIVO -->

      <div
        class="revoke-selection-hint"
        *ngIf="!selectedPermission"
      >

        <i class="pi pi-info-circle"></i>

        <span>
          Seleziona un permesso per visualizzarne
          i dettagli prima della revoca.
        </span>

      </div>

      <!-- DETTAGLI PERMESSO -->

      <ng-container *ngIf="selectedPermission as permission">

        <div class="revoke-details-header">

          <i class="pi pi-file-edit"></i>

          <span>
            Dettagli del permesso
          </span>

        </div>

        <div class="revoke-details-grid">

          <div class="revoke-detail-card">

            <span class="revoke-detail-label">
              Data permesso
            </span>

            <span class="revoke-detail-value">
              {{ permission.permissionDate | date:'dd/MM/yyyy' }}
            </span>

          </div>

          <div class="revoke-detail-card">

            <span class="revoke-detail-label">
              Totale ore
            </span>

            <span class="revoke-detail-value">
              {{ permission.totalTime }}
            </span>

          </div>

          <div class="revoke-detail-card">

            <span class="revoke-detail-label">
              Articolo
            </span>

            <span class="revoke-detail-value">
              Art. {{ permission.article }}
            </span>

          </div>

          <div class="revoke-detail-card">

            <span class="revoke-detail-label">
              Giornaliero
            </span>

            <span class="revoke-detail-value">
              {{ permission.isDaily ? 'Sì' : 'No' }}
            </span>

          </div>

          <div class="revoke-detail-card revoke-detail-wide">

            <span class="revoke-detail-label">
              Protocollo
            </span>

            <span class="revoke-detail-value">
              {{ permission.permissionProtocol?.protocolId || 'Non disponibile' }}
            </span>

          </div>

        </div>

        <div class="revoke-warning">

          <i class="pi pi-exclamation-triangle"></i>

          <span>
            Confermando, verrà avviata la procedura
            di revoca del permesso selezionato.
          </span>

        </div>

      </ng-container>

    </div>

    <!-- CONFERMA REVOCA -->

    <div class="revoke-dialog-actions">

      <p-button
        label="Conferma revoca"
        icon="pi pi-check"
        styleClass="revoke-confirm-button"
        [loading]="saving"
        [disabled]="!selectedPermission || saving"
        (onClick)="confirm()"
      ></p-button>

    </div>

  </ng-container>

</div>